class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.openTimeout = null;
    this.closeTimeout = null;
    
    // Add hover support for desktop mega menu
    if (window.matchMedia('(min-width: 1280px)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
      this.content.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.content.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onMouseEnter() {
    window.clearTimeout(this.openTimeout);
    window.clearTimeout(this.closeTimeout);

    this.openTimeout = window.setTimeout(() => {
      if (this.matches(':hover') || this.content.matches(':hover')) {
        if (!this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.setAttribute('open', '');
          this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
        }
      }
    }, 100);
  }

  onMouseLeave() {
    window.clearTimeout(this.openTimeout);
    window.clearTimeout(this.closeTimeout);

    this.closeTimeout = window.setTimeout(() => {
      if (!this.matches(':hover') && !this.content.matches(':hover')) {
        this.close();
      }
    }, 180);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
